import { Controller } from '@hotwired/stimulus'

export default class UserMenuController extends Controller {
  static targets = ['trigger', 'offcanvas'];

  #resizeHandler = null;

  connect() {
    this.#resizeHandler = this.positionMenu.bind(this);
    window.addEventListener('resize', this.#resizeHandler);
  }

  disconnect() {
    window.removeEventListener('resize', this.#resizeHandler);
  }

  positionMenu() {
    if (!window.matchMedia('(min-width: 992px)').matches) return;

    const rect = this.triggerTarget.getBoundingClientRect();
    this.offcanvasTarget.style.right = `${window.innerWidth - rect.right}px`;
  }
}
